/**
 * /tax-regime-selector — cold-start tax-planning tool.
 *
 * Sits under the protected layout (auth required). The TaxRegimeSelector
 * feature component handles the full wizard → result flow internally; the
 * route is a thin shell.
 */
import { createFileRoute } from '@tanstack/react-router';
import { TaxRegimeSelector } from '@/features/tax-regime-selector/tax-regime-selector';

export const Route = createFileRoute('/_protected/tax-regime-selector')({
  component: TaxRegimeSelectorPage,
});

function TaxRegimeSelectorPage() {
  return <TaxRegimeSelector />;
}
